import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, forkJoin, of } from 'rxjs';
import { catchError, filter, finalize, map, take } from 'rxjs/operators';
import { DataAccessService } from './data-access.service';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { NotificationService } from 'src/app/shared/services/notification.service';





const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'multipart/form-data' })
};
export interface OptionType {

}
@Injectable({
  providedIn: 'root'
})
export class StoresService {
  user: any;
  urlUpload!: string;
  private selectedOptionSubject = new BehaviorSubject<OptionType | null>(null);
  constructor(private afs: AngularFirestore, private cas: DataAccessService, private storage: AngularFireStorage, private http: HttpClient,
    private notificationService: NotificationService) { }


  getStoreAnalytics(platform: string, channel: string, shop: string) {
    return this.afs.doc(`${platform}/${shop}/analytics/${channel}`).snapshotChanges().pipe(
      take(1),
      map(a => {
        const data = a.payload.data() as any;
        const id = a.payload.id;
        const path = a.payload.ref.path;
        return {
          id,
          path,
          ...data
        };
      })
    );
  }

  getStoreChannelInfo(platform: string, channel: string, shop: string) {
    if (!platform || !channel || !shop) {
      return of(null);
    }
    return this.afs.doc(`${platform}/${shop}/appData/${channel}`).snapshotChanges().pipe(
      take(1),
      map(a => {
        if (!a.payload.exists) {
          return null;
        }
        const data = a.payload.data() as any;
        const id = a.payload.id;
        const path = a.payload.ref.path;
        return {
          id,
          path,
          ...data
        };
      }),
      catchError(() => of(null))
    );
  }

  async updateStoreChannelInfo(platform: string, shop: string, channel: string, body: any) {
    return new Promise((resolve, reject) => {
      this.afs.firestore.doc(`${platform}/${shop}/appData/${channel}`).set(body, { merge: true });
      resolve("success channel");
    });
  }

  getStoreVoiceshoppingChannel(platform: string, shop: string, channel: string): any {
    return this.afs.doc(`${platform}/${shop}/appData/voice-shopping/${channel}/appData`).snapshotChanges().pipe(
      map(a => {
        const data = a.payload.data() as any;
        const id = a.payload.id;
        const path = a.payload.ref.path;
        return {
          id,
          path,
          ...data
        };
      })
    );
  }

  updateNewStoreGeneral(platform: string, shop: string, body: any) {
    return new Promise((resolve, reject) => {
      const batch = this.afs.firestore.batch();
      const ref1 = this.afs.firestore.doc(`${platform}/${shop}`);
      batch.set(ref1, body, { merge: true });
      resolve(batch.commit());
    });
  }

  async updateNewStoreVoiceChannel(platform: string, shop: string, botType: string, body: any) {
    return new Promise((resolve, reject) => {
      const batch = this.afs.firestore.batch();
      const ref3 = this.afs.firestore.doc(`${platform}/${shop}/appData/voice-shopping/${botType}/appData`);
      batch.set(ref3, body, { merge: true });
      resolve(batch.commit());
    });
  }

  async updateNewStoreVoiceShopping(platform: string, shop: string, botType: string, body1: any, body2: any) {
    const batch = this.afs.firestore.batch();
    const ref1 = this.afs.firestore.doc(`${platform}/${shop}/appData/voice-shopping`);
    batch.set(ref1, body1, { merge: true });
    const ref2 = this.afs.firestore.doc(`${platform}/${shop}/appData/voice-shopping/${botType}/appData`);
    batch.set(ref2, body2, { merge: true });
    return await batch.commit();
  }

  updateBotWithStoreinfo(botId: string, body: any) {
    return this.afs.doc(`bots/${botId}`).set(body, { merge: true })
      .then(
        () => {
        })
      .catch(
        () => { console.log('Something went wrong'); });
  }

  getStores(platform: string, userID: string): any {
    return this.cas.getResponseStoresofuser(platform, userID);

  }

  /**
   * Get all stores for a user across all supported platforms
   * @param userID - The user ID to get stores for
   * @returns Observable containing all stores as a flat array
   */
  getAllStoresForUser(userID: string): any {
    return this.cas.getAllStoresForUserSequential(userID);
  }

  updateBotInfo(botId: string, body: any): Promise<void> {
    return this.afs.doc(`bots/${botId}`).set(body, { merge: true });
  }

  updateStoreInfoNew(path: string, body: any): Promise<void> {
    return this.afs.doc(path).set(body, { merge: true });
  }

  generateScript(platform: string, shop: string): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      return this.afs.firestore.doc(`${platform}/${shop}/appData/scripts`).get().then(doc => {
        if (doc.exists) {
          const data = doc.data() as any;

          // Your script generation logic here...

          const scriptToAdd = `
            <script type="text/javascript">
              // Your generated script...
            </script>`;

          const fileRef = this.storage.ref(`modules/${platform}/${shop}/conversell.js`);
          return fileRef.putString(scriptToAdd, 'raw', { contentType: 'application/javascript' })
            .snapshotChanges()
            .pipe(
              finalize(async () => {
                return resolve(scriptToAdd);
              })
            )
            .subscribe(() => fileRef.getDownloadURL().subscribe(urlUpload => {
              this.urlUpload = urlUpload;
            }));
        } else {
          reject("No such document!");
          return 1;
        }
      }).catch(error => {
        console.log('Something went wrong');
        return error;
      });
    });
  }

  getStoreChannelInfoNew(platform: string, channel: string, shop: string): Observable<any> {
    if (!platform || !channel || !shop) {
      return of(null);
    }
    return this.afs.doc(`${platform}/${shop}/appData/${channel}`).snapshotChanges().pipe(
      take(1),
      map(a => {
        if (!a.payload.exists) {
          return null;
        }
        const data = a.payload.data() as any;
        const id = a.payload.id;
        const path = a.payload.ref.path;
        return {
          id,
          path,
          ...data
        };
      }),
      catchError(() => of(null))
    );
  }

  getStore(platform: string, shop: string): Observable<any> {
    if (!platform || !shop) {
      return of(null);
    }
    return this.afs.doc(`${platform}/${shop}`).snapshotChanges().pipe(
      // The first snapshot is often an empty cache miss. Waiting for a cached
      // hit or the server response avoids treating a real workspace as empty.
      filter((change) => !change.payload.metadata?.fromCache || !!change.payload.exists),
      take(1),
      map(a => {
        if (!a.payload.exists) {
          return null;
        }
        const data = a.payload.data() as any;
        const id = a.payload.id;
        const path = a.payload.ref.path;
        return {
          id,
          path,
          ...data
        };
      }),
      catchError(() => of(null))
    );
  }

  getStoreCatalogs(path: string): Observable<any[]> {
    if (!path || typeof path !== 'string' || path.trim() === '') {
      return new Observable(observer => {
        observer.error(new Error('Invalid catalog path provided'));
        observer.complete();
      });
    }

    return this.afs.collection<any>(path).snapshotChanges().pipe(
      map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          const id = a.payload.doc.id;
          const path = a.payload.doc.ref.path;
          return {
            id,
            path,
            ...data
          };
        });
      }),
      catchError(error => {
        // Handle specific Firebase errors
        if (error?.code === 'permission-denied' || error?.message?.includes('Missing or insufficient permissions')) {
          this.notificationService.show('error', 'You do not have permission to access catalogs. Please check your access rights.');
        } else if (error?.code === 'not-found') {
          return of([]); // Return empty array instead of error
        } else {
          this.notificationService.show('error', `Error loading catalogs: ${error?.message || 'Unknown error'}`);
        }

        // Return empty array on error to prevent breaking the UI
        return of([]);
      })
    );
  }
  getCatalog(platform: string, storeId: string, catalogId: string): Observable<any> {
    return this.afs.doc(`/${platform}/${storeId}/catalogs/${catalogId}`).snapshotChanges().pipe(
      take(1),
      map(a => {
        const data = a.payload.data() as any;
        const id = a.payload.id;
        const path = a.payload.ref.path;
        return {
          id,
          path,
          ...data
        };
      })
    );
  }
  updateCatalog(platform: string, storeId: string, catalogId: string, body: any): Observable<any> {
    return new Observable((observer) => {
      this.afs.doc(`/${platform}/${storeId}/catalogs/${catalogId}`).set(body, { merge: true })
        .then(() => {
          observer.next({ success: true });
          observer.complete();
        })
        .catch((error) => {
        console.log('Something went wrong');
          observer.error(error);
        });
    });
  }

  getStoreGeneralStats(platform: string, shop: string, channel: string): Observable<any> {
    if(channel === 'messenger') channel='facebook'
    return this.afs.doc(`${platform}/${shop}/Analytics/${channel}`).snapshotChanges().pipe(
      take(1),
      map(a => {
        const data = a.payload.data() as any;
        const id = a.payload.id;
        const path = a.payload.ref.path;
        return {
          id,
          path,
          ...{ data }
        };
      })
    );
  }

  // Get all analytics data from the Analytics collection
  getAllStoreAnalytics(platform: string, shop: string): Observable<any[]> {
    return this.afs.collection(`${platform}/${shop}/Analytics`).snapshotChanges().pipe(
      take(1),
      map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          const id = a.payload.doc.id;
          const path = a.payload.doc.ref.path;
          return {
            id,
            channel: id, // The document ID is the channel name
            path,
            data
          };
        });
      })
    );
  }

  async updateNewStoreConversationalShopping(platform, shop, botType, body1, body2) {

    var batch = this.afs.firestore.batch();
    var ref1 = this.afs.firestore.doc(`${platform}/${shop}`);
    batch.set(ref1, body1, { merge: true });
    var ref2 = this.afs.firestore.doc(`${platform}/${shop}/appData/conversational-shopping`);
    batch.set(ref2, body2, { merge: true });
    return await batch.commit();
  }

  selectedOption$: Observable<any> = this.selectedOptionSubject.asObservable();

  setSelectedOption(option: string | null) {
    this.selectedOptionSubject.next(option);
  }

  clearSelectedOption() {
    this.selectedOptionSubject.next(null);  // Réinitialiser la valeur
  }


}
